module.exports = __webpack_public_path__ + "static/img/10commitments_10.db41882.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/10commitments_10.jpg
// module id = l9DO
// module chunks = 0